module.exports = __webpack_public_path__ + "fonts/SummerLoving_Solid.c3ae7ce580779d740c41eb448b035a0b.otf";